import { StepListItem } from './stepListItem';
import { Supplimental } from './supplimental';


export class Step {
   public static readonly STEP_TYPE_ADV = "advertisement";

   title: string;
   image: string;
   description: string;
   objective: string; //Used to provide tooltip information
   list: StepListItem[];
   type: string;
   summary: string;
   supplimentals: Supplimental[];
   
   
   constructor(type: string, title: string, image: string, description: string, objective: string, list: StepListItem[], supplimentals: Supplimental[], summary?: string) {
      this.type = type;
      this.title = title;
      this.image = image;
      this.description = description;
      this.objective = objective;
      this.list = list;
      this.summary = summary ?? '';
      this.supplimentals = supplimentals
   }

}